module.exports = __webpack_public_path__ + "static/media/83.a269c6f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/83.wav
// module id = zNaR
// module chunks = 0